import * as actionTypes from 'actions/actionTypes';
import { hashValueIfExists } from 'utils/analytics/hashSHA256';
import { getAnalyticsPathData } from 'utils/analytics/pathUtils';

const LOGIN_EVENTS = ['login_start', 'login_attempt', 'login_success', 'login_error'];

const ensureValue = (value) => (value || value === 0 ? value : 'undefined');

const getAuthAnalyticsObject = (state, action) => {
  const { meta } = action;
  const hasErrorCode = meta.errorCode !== undefined;

  if (!LOGIN_EVENTS.includes(meta.event)) {
    return null;
  }

  const { authentication = {} } = state;
  const email = authentication.email || authentication.emailPending;
  const { path, page } = getAnalyticsPathData(window.location.pathname);

  const analyticsObject = {
    event: meta.event,
    path: ensureValue(path),
    page: ensureValue(page),
    ab_testing_group: 'undefined',
    user_id: ensureValue(authentication.id),
    client_type: 'existing',
    logged: 'not_logged_in',
    email: ensureValue(hashValueIfExists(email)),
    phone: ensureValue(hashValueIfExists(authentication.msisdn)),
    credit_score: 'undefined',
    product: 'undefined',
    application_id: 'undefined',
    target: 'undefined',
    contract_id: 'undefined',
  };

  if (hasErrorCode) {
    analyticsObject.error_code = ensureValue(meta.errorCode);
  }

  return analyticsObject;
};

export default (store) => (next) => (action) => {
  const isDataLayerAvailable = window.dataLayer && window.dataLayer.push;

  if (!isDataLayerAvailable) {
    return next(action);
  }

  const { meta, type } = action;
  const isTrackAnalyticsAction = type === actionTypes.TRACK_ANALYTICS_DATA && meta && meta.event;

  if (isTrackAnalyticsAction) {
    const state = store.getState();
    const analyticsData = getAuthAnalyticsObject(state, action);

    if (analyticsData) {
      if (DEBUG) {
        console.table(analyticsData);
      }
      window.dataLayer.push(analyticsData);
    }
  }

  return next(action);
};
